import ClaimDetailsStatusHistory from './ClaimDetailsStatusHistory';

export default ClaimDetailsStatusHistory;
